const STOREFRONT_CSS = process.env.STOREFRONT_CSS;

const disablePricePlaceholderStyles = () => {
  const stylesheet = Array.from(document.styleSheets).find(
    ({ href }) => href === STOREFRONT_CSS
  );
  stylesheet.disabled = true;
};

const enablePricePlaceholderStyles = () => {
  const stylesheet = Array.from(document.styleSheets).find(
    ({ href }) => href === STOREFRONT_CSS
  );
  stylesheet.disabled = false;
};

export { disablePricePlaceholderStyles, enablePricePlaceholderStyles };
